import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../auth";
import { toast } from "sonner";
import { TCMLogo } from "../components/TCMLogo";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      if (user.role === "admin" || user.role === "staff") nav("/admin");
      else nav("/trips");
    } catch (err) {
      toast.error("Email or password incorrect");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen" data-testid="login-page">
      <div className="px-6 lg:px-8 py-5 flex items-center">
        <Link to="/" aria-label="The Curated Mile — Home">
          <TCMLogo size="md" />
        </Link>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-10">
            <div className="flex justify-center mb-4"><TCMLogo size="xl" /></div>
            <p className="tcm-eyebrow">Client Portal</p>
          </div>
          <div className="tcm-double-frame">
            <div className="tcm-inner p-8">
              <form onSubmit={submit} className="space-y-6" autoComplete="on">
                <div>
                  <label className="tcm-eyebrow block mb-2" htmlFor="login-email">Email</label>
                  <input id="login-email" name="email" autoComplete="username"
                         data-testid="login-email-input" type="email" className="tcm-input" required
                         value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div>
                  <label className="tcm-eyebrow block mb-2" htmlFor="login-password">Password</label>
                  <input id="login-password" name="password" autoComplete="current-password"
                         data-testid="login-password-input" type="password" className="tcm-input" required
                         value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <button data-testid="login-submit-button" type="submit" disabled={busy}
                        className="tcm-btn-primary w-full">
                  {busy ? "Signing in..." : "Enter portal"}
                </button>
              </form>
              <div className="mt-6 pt-5 border-t border-[color:var(--tcm-navy-15)] text-center">
                <p className="text-[12px] text-[color:var(--tcm-navy-70)] mb-2">
                  Can't remember your password?
                </p>
                <Link data-testid="forgot-link" to="/forgot"
                      className="inline-block tcm-btn-outline text-[11px] py-2 px-4">
                  Reset my password
                </Link>
              </div>
            </div>
          </div>
          <div className="mt-8 text-center">
            <a data-testid="back-to-marketing" href="https://www.the-curated-mile.com"
               className="tcm-eyebrow underline decoration-[#C9A961] underline-offset-4">
              ← the-curated-mile.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
